import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Miami needed",
      "Ideal for FAU students studying abroad",
      "Perfect for snowbird residents with international travel plans",
      "Great for Boca Raton corporate and tech professionals",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Palm Beach County post offices",
      "Good for planned international trips from Boca Raton",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Boca area facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Miami — ~50 miles via I-95",
      "NPIC appointment required before driving south",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function BocaProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Boca Raton"
      headingExtra="FL"
      introText="Boca Raton and South Palm Beach County travelers — FAU students heading abroad, snowbird residents with international travel plans, corporate professionals at the Boca Raton Innovation Campus, and families flying out of Fort Lauderdale-Hollywood International (FLL) — have several options for getting a passport fast. Here is how they compare, and why most Boca Raton residents choose a U.S. Department of State registered passport courier for fast, professional processing."
      options={options}
      emergencyDescription="Boca Raton does not have its own regional passport agency. The closest agency is in downtown Miami at 1501 Biscayne Blvd Suite 210 — approximately 50 miles south via I-95, though Miami traffic can easily stretch this to 1.5+ hours. You must obtain an NPIC appointment before traveling, and walk-ins are not accepted at the Miami Passport Agency."
      disclaimerText="*Processing speed depends on eligibility and documentation. Boca Raton does not have a regional passport agency — the closest is Miami, roughly 50 miles away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}